export default __webpack_public_path__ + "7c700b6c5d8e420dd8655ed5a8003f1b.png";